import AccordionItem from './AccordionItem'

const CustomerAccordionItem = ({
  relatedCustomers, 
  evidences, 
  scrollToElement
}: {
  relatedCustomers: any [], 
  evidences: any [],
  scrollToElement: (customerId: string) => void
}) => {
  
  return (
    <>
      {relatedCustomers.map((customer) => (
        <AccordionItem 
          key={customer?._id} 
          customer={customer} 
          evidences={evidences}
          relatedCustomers={relatedCustomers}
          scrollToElement={scrollToElement}
        />
      ))}
    </>
  )
}

export default CustomerAccordionItem